import { computed } from 'vue';
import { useStore } from 'vuex';

export const useSnacks = () => {
  const store = useStore();

  const snacks = computed(() => store.getters["snacksStore/snacks"]);
  const addSnackbar = (text, color) => store.commit("snacksStore/add", text, color);

  return { snacks, addSnackbar };
};